<template>
  <BaseDetailLayout title="Home" :isBackBtnVisible="false">
    <template #detail>
      <v-row class="ma-0 h-100">
        <v-col cols="12" md="3" lg="3" class="pr-2 d-flex flex-column">
          <v-card elevation="0" class="ma-0 pa-0 rounded-lg">
            <v-row no-gutters v-if="customerDetail && customerDetail.customer">
              <v-col class="pa-4" cols="12" md="3" lg="4">
                <v-img
                  v-if="
                    customerDetail &&
                    customerDetail.user &&
                    customerDetail.user.profile_image
                  "
                  :src="customerDetail.user.profile_image"
                  contain
                  class="rounded-circle"
                />
                <v-img
                  v-else
                  :src="driverImage"
                  contain
                  class="rounded-circle"
                />
              </v-col>
              <v-col cols="12" md="7" lg="8" class="pl-2 d-flex align-center">
                <div>
                  <h4 v-if="customerDetail.customer.name">
                    <BaseTooltip
                      title="full name"
                      :text="customerDetail.customer.name"
                    />
                  </h4>
                  <div class="text-subtitle-1 font-weight-bold d-flex">
                    <h5
                      class="text_color--text"
                      style="text-transform: capitalize"
                      v-if="customerDetail.customer.contact_number"
                    >
                      <BaseTooltip
                        title="contact number"
                        :text="customerDetail.customer.contact_number"
                      />
                    </h5>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
          <v-card elevation="0" class="mt-3 h-100 rounded-lg">
            <v-card-title class="px-3 py-1">
              <v-row no-gutters>
                <v-col cols="6">
                  <h6>{{ customerModule.customer }} Details</h6>
                </v-col>
                <v-col cols="6" class="text-right"> </v-col>
              </v-row>
            </v-card-title>
            <v-divider></v-divider>

            <v-card-subtitle v-if="customerDetail && customerDetail.customer">
              <div
                v-for="(value, key, index) in customerDetail.customer"
                :key="index"
              >
                <v-row no-gutters class="pt-1 px-2" v-if="key != 'id'">
                  <v-col md="5" lg="6">
                    <h5 class="text_color--text text-capitalize">
                      {{ key.replace(/_/g, "  ") }}
                    </h5>
                  </v-col>
                  <v-col
                    md="7"
                    lg="6"
                    v-if="
                      ['email_notification', 'whatsapp_notification'].indexOf(
                        key
                      ) > -1
                    "
                  >
                    <v-icon :color="value ? 'success' : 'error'">
                      {{
                        value ? "mdi-check-circle" : "mdi-close-circle"
                      }}</v-icon
                    >
                  </v-col>
                  <v-col md="7" lg="6" v-else>
                    <h5>{{ value }}</h5>
                  </v-col>
                </v-row>
              </div>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" md="9" lg="9" class="pl-1">
          <section>
            <div
              v-if="customerDetail && customerDetail.customer_statics"
              class="mb-3"
            >
              <v-row no-gutters>
                <v-col
                  v-for="(value, key, index) in customerDetail.customer_statics"
                  :key="index"
                  :class="
                    Object.keys(customerDetail.customer_statics).length - 1 ==
                    index
                      ? 'pr-0'
                      : 'pr-3'
                  "
                >
                  <v-card elevation="0" class="h-100 rounded-lg pt-0">
                    <v-card-text
                      class="px-4 py-2 h-100 d-flex flex-column justify-space-between"
                    >
                      <span
                        class="text_color--text text-capitalize text-center text-caption font-weight-bold d-flex justify-center"
                        v-if="key == 'order_in_last_seven_days'"
                      >
                        orders in 7 days
                      </span>
                      <span
                        v-else
                        class="text_color--text text-capitalize text-center text-caption font-weight-bold d-flex justify-center"
                      >
                        {{ key.replace(/_/g, "  ") }}
                      </span>

                      <div class="d-flex align-center justify-space-around">
                        <v-icon :color="orderAnalyticsColor[key]">
                          {{ orderAnalyticsIcon[key] }}</v-icon
                        >

                        <span class="text-caption">
                          <h3>{{ value }}</h3>
                        </span>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <v-card elevation="0" class="rounded-lg">
              <v-row no-gutters>
                <v-col cols="6" class="d-flex align-center pl-2">
                  <h4 class="text-capitalize text-subtitle-2">
                    {{ orderModule.orderPlural }}
                  </h4>
                </v-col>
                <v-col cols="6">
                  <v-tabs v-model="tab" right>
                    <v-tab>
                      <h4
                        class="text-caption font-weight-bold app-driver-font-tab"
                      >
                        Today
                      </h4>
                    </v-tab>

                    <v-tab>
                      <h4
                        class="text-caption font-weight-bold app-driver-font-tab"
                      >
                        Last 7 days
                      </h4>
                    </v-tab>
                    <v-tab>
                      <h4
                        class="text-caption font-weight-bold app-driver-font-tab"
                      >
                        Next 7 days
                      </h4>
                    </v-tab>
                  </v-tabs>
                </v-col>
                <v-col cols="12" style="height: calc(100vh - 320px)">
                  <AgGridVue
                    @grid-ready="gridReady"
                    :grid-options="gridOptions"
                    :column-defs="tableHeader"
                    :default-col-def="defaultColDef"
                    :row-data="orderList"
                    :context="context"
                    style="width: 100%; height: calc(100vh - 334px)"
                    class="ag-theme-balham px-4 pt-4"
                  >
                  </AgGridVue>
                </v-col>
                <v-col cols="6" class="pl-3 d-flex justify-start align-center">
                  <PaginationCount :total="totalCount" />
                </v-col>
                <v-col cols="6" class="d-flex justify-end">
                  <Pagination
                    :pageNo="pageNo"
                    :totalItems="totalCount"
                    :pageSize="itemsPerPage"
                    @itemsPerPageChange="itemsPerPageChange"
                    @prevPage="prevPage"
                    @nextPage="nextPage"
                  />
                </v-col>
              </v-row>
            </v-card>
          </section>
        </v-col>
      </v-row>
    </template>
    <template #dialog> </template>
  </BaseDetailLayout>
</template>

<script>
import { bus } from "@/main.js";
import driverImage from "@/assets/profile.jpg";
import BaseTooltip from "@/components/BaseComponents/BaseTooltip.vue";
import { AgGridVue } from "ag-grid-vue";
import Pagination from "@/components/BaseComponents/Pagination.vue";
import TripTooltipWithIcon from "@/components/ModuleBasedComponents/Trip/TripTooltipWithIcon.vue";
import { returnToday } from "@/utils/functions";
import PaginationCount from "@/components/BaseComponents/PaginationCount.vue";
import ConsigneeOrderButton from "@/components/Button/ConsigneeOrderButton.vue";
import {
  fleetModule,
  customerModule,
  orderModule,
} from "@/utils/moduleMapping";
import BaseDetailLayout from "@/components/LayoutComponents/BaseDetailLayout.vue";

export default {
  components: {
    BaseTooltip,
    AgGridVue,
    Pagination,
    TripTooltipWithIcon,
    PaginationCount,
    ConsigneeOrderButton,
    BaseDetailLayout,
  },
  data() {
    return {
      customerModule,
      fleetModule,
      orderModule,
      driverImage,
      tab: 0,
      userDetails: this.$helper.getUserDetailsLocalStorage(),
      customerDetail: {},
      defaultColDef: {
        lockPosition: true,
        // flex: 1,
        resizable: true,
        sortable: true,
        autoHeight: true,
        cellStyle: {
          "text-overflow": "ellipsis",
          "white-space": "nowrap",
          overflow: "hidden",
          display: "block",
        },
      },

      orderList: [],
      itemsPerPage: 10,
      pageNo: 1,
      orderAnalytics: {
        orders_in_seven_days: 82,
        total_orders: 1382,
        total_addresses: 1034,
      },
      orderAnalyticsColor: {
        order_in_last_seven_days: "pickedup",
        total_orders: "failed",
        total_addresses: "on_hold",
      },
      orderAnalyticsIcon: {
        order_in_last_seven_days: "mdi-calendar-today",
        total_orders: "mdi-archive",
        total_addresses: "mdi-map-marker",
      },
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridOptions.api.sizeColumnsToFit();
        },
        headerHeight: 40,
        rowHeight: 40,
        rowSelection: "multiple",
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
      },
      columnDefs: [
        {
          headerName: "reference number",
          headerTooltip: "Reference Number",
          field: "reference_number",
          pinned: "left",
          minWidth: 200,
        },
        {
          headerName: "Execution Date",
          field: "execution_date",
        },
        {
          headerName: "Delivery Date",
          field: "delivery_date",
        },
        {
          headerName: "Status",
          field: "verbose_status",
        },
        {
          headerName: "Address",
          field: "address",
          tooltipField: "address",
        },
        {
          headerName: "Weight",
          field: "weight",
        },
        {
          headerName: "Volume",
          field: "volume",
        },
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          sortable: false,
          minWidth: 150,
          maxWidth: 150,
          cellRenderer: "ConsigneeOrderButton",
        },
      ],

      totalCount: 0,
      orderFilter: {
        execution_date: returnToday(),
      },
    };
  },
  computed: {
    tableHeader() {
      if (this.$helper.isCompanyHasItems()) {
        this.columnDefs.splice(6, 0, {
          headerName: "No Of Items",
          field: "total_items",
        });
      }
      return this.columnDefs;
    },
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
    totalPages() {
      return Math.ceil(this.totalCount / this.itemsPerPage);
    },
    context() {
      return { parentComponent: this };
    },
  },
  watch: {
    tab(val) {
      if (val == 0) {
        this.orderFilter = {
          execution_date: returnToday(),
        };
        this.getConsigneeOrderList();
      } else if (val == 1) {
        this.orderFilter = {
          from_date: returnToday(-7),
          to_date: returnToday(-1),
        };
        this.getConsigneeOrderList();
      } else if (val == 2) {
        this.orderFilter = {
          from_date: returnToday(1),
          to_date: returnToday(7),
        };
        this.getConsigneeOrderList();
      }
    },
  },
  methods: {
    nextPage() {
      this.pageNo++;
      this.getConsigneeOrderList();
    },

    prevPage() {
      this.pageNo--;
      this.getConsigneeOrderList();
    },

    itemsPerPageChange(value) {
      this.pageNo = 1;
      this.itemsPerPage = value;
      this.getConsigneeOrderList();
    },

    gridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
    },
    getConsigneeDetails(id) {
      bus.$emit("showLoader", true);
      this.$api.consigneeManagement
        .getConsigneeDetails(id)
        .then((res) => {
          this.customerDetail = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    getConsigneeOrderAttachment(id) {
      bus.$emit("showLoader", true);
      this.$api.consigneeManagement
        .getConsigneeOrderAttachment(id)
        .then((res) => {
          bus.$emit("showLoader", false);
          let generatedPDFBlob = new Blob([res.data], {
            type: "application/pdf",
          });
          var pdfUrl = URL.createObjectURL(generatedPDFBlob);
          window.open(pdfUrl);
        })
        .catch((error) => {
          bus.$emit("showLoader", false);
          console.error(error);
        });
    },
    getConsigneeOrderList(params = {}) {
      params = {
        ...params,
        offset: this.offset,
        ...this.orderFilter,
        limit: this.itemsPerPage,
        driver: this.$route.params.id,
      };

      if (this.search) {
        params.search = this.search;
      }
      bus.$emit("showLoader", true);
      this.$api.consigneeManagement
        .getConsigneeOrderList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.orderList = res.data;
          this.totalCount = res.count;
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  mounted() {
    this.getConsigneeDetails(this.userDetails.id);
    this.getConsigneeOrderList();
  },
};
</script>

<style scoped>
.app-driver-font-tab {
  font-family: roboto;
  text-transform: capitalize;
  letter-spacing: 0.1px;
}
.main-drivers-layout {
  height: 100%;
}
.template-grid {
  display: grid;
  grid-template-columns: 400px 1fr 400px;
  grid-column-gap: 8px;
  height: calc(100vh - 130px);
}

.card-vehicle-analytic-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 9px;
}
.template-grid .template-grid-content {
  display: grid;
  grid-template-rows: 100px 1fr;
  grid-column-gap: 8px;
  height: calc(100vh - 130px);
  overflow-y: hidden;
  overflow-x: auto;
}
.template-grid .template-grid-content > div {
  /* border:1px solid red */
}
</style>
